export const SVG_LOADING = 'Loading';
export const SVG_LOGO = 'Logo';
export const SVG_PLAN = 'Plan';
export const SVG_SLASH = 'Slash';
export const SVG_SUNRAY = 'Sunray';

export type SvgLoading = typeof SVG_LOADING;
export type SvgLogo = typeof SVG_LOGO;
export type SvgPlan = typeof SVG_PLAN;
export type SvgSlash = typeof SVG_SLASH;
export type SvgSunray = typeof SVG_SUNRAY;

export type CustomSvgIconName =
  | SvgLoading
  | SvgLogo
  | SvgPlan
  | SvgSlash
  | SvgSunray;

export interface CustomSvgIconComponent {
  name: CustomSvgIconName;
  component: React.FC<any>;
}
